<template>
    <div ref="pie" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {chartMerge} from 'echarts-config';
import {pieData} from '@/runtime-components/data';

export default {
    name: 'de-pie',
    props: {
        legendOrient: {
            type: String,
            default: 'vertical'
        },
        colorSeries: {
            type: Array
        },
        outradius: {
            type: Number,
            default: 70
        },
        innerradius: {
            type: Number,
            default: 50
        },
        data: {
            type: Array,
            default: () => {
                return pieData.data;
            }
        },
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        legendOrient(v) {
            let chartIns = this.getChart().chart;
            let legend = v === 'horizontal' ? { orient: v, left: 0, right: 10, top: 6, width: '100%' } : {orient: v, top: '25%', right: 0};
            chartIns && (chartIns.setOption({
                legend: legend
            }));
        },
        outradius() {
            let chartIns = this.getChart().chart;
            chartIns && (chartIns.setOption({
                series: [{
                    radius: [`${this.innerradius}%`, `${this.outradius}%`]
                }]
            }));
        },
        innerradius() {
            let chartIns = this.getChart().chart;
            chartIns && (chartIns.setOption({
                series: [{
                    radius: [`${this.innerradius}%`, `${this.outradius}%`]
                }]
            }));
        },
        colorSeries: {
            handler(newVal) {
                let chartIns = this.getChart().chart;
                chartIns && (chartIns.setOption({
                    color: newVal
                }));
            },
            deep: true
        },
        data:{
            handler(newVal) {
                let chartIns = this.getChart().chart;
                let legendData = newVal.map(item=>item.name);
                chartIns && (chartIns.setOption({
                    series:[{
                        data: newVal
                    }],
                    legend: {
                        data: legendData
                    }
                }));
            },
            deep: true
        }
    },
    methods: {
        initChart(type) {
            let chartIns = this.getChart();
            //初始化设置主题 dark light
            window._CHART_THEMETYPE_ = type || 'dark';
            let legend = this.legendOrient === 'horizontal' 
            ? { type: 'scroll', orient: this.legendOrient, left: 0, right: 12, top: 6, width: '100%' } 
            : { type: 'scroll', orient: this.legendOrient, top: '20%', right: 0 };
            //echarts1
            const chart = chartMerge(
                {
                    chartType: 'Pie'
                }, {
                    legend: legend,
                    series: [{
                        data: this.data,
                        radius: [`${this.innerradius}%`, `${this.outradius}%`]
                    }]
                });
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['pie']);
                chartIns.chart.setOption(chart);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style scoped>
@import url('~@/runtime-components/assets/common.css');
</style>